<div class="multi-container row" [dir]="language == 'ar' ? 'rtl' : 'ltr'">
  <h3 *ngIf="data?.title">{{ data.titleTr }}</h3>
  <div class="col-12 col-md-7 order-2 order-md-1">
    <div [innerHTML]="data.htmlContent" *ngIf="data?.htmlContent"></div>
  </div>
  <div class="image col-12 col-md-5 order-1 order-md-2" *ngIf="data?.imageUrl">
    <p-galleria
      [value]="data.imageUrl"
      [showItemNavigators]="true"
      [showThumbnails]="false"
      [showIndicators]="true"
      [showIndicatorsOnItem]="false"
      [autoPlay]="true"
      [circular]="true"
    >
      <ng-template pTemplate="item" let-item>
        <img [src]="item" class="img-view" />
      </ng-template>
    </p-galleria>

    <!-- <figure *ngFor="let item of data?.imageUrl">
      <img width="100%" [src]="item" />
    </figure> -->
  </div>
</div>
